/**
 * 项目域 MCP facade（`dosia-projects`）— 跨进程契约常量单源。
 *
 * 企业后端（apps/web）把「项目」这块能力以 streamable-http MCP endpoint 的
 * 形态对外暴露，和 catalyst-juguang 同构：服务端 facade 持有编排与权限，
 * 客户端只拿一个短时效的身份 token。
 *
 * 这里只放两端都要认的字面量。任何一端把这些值抄成本地常量都会漂移，
 * 所以 server / client / 测试一律从此处导入。
 *
 * 身份 token 与聚光 token **刻意不共用**：audience 隔离是本设计要点，
 * 一条腿的 token 泄漏不得横向打开另一条腿。
 */
/** MCP server name。也是企业插件授权表（managedPlugins/forbiddenPlugins）里的键。 */
export const DOSIA_PROJECTS_MCP_SERVER_NAME = "dosia-projects";
/** 客户端进程里承载用户身份 token 的环境变量名。 */
export const DOSIA_PROJECTS_USER_TOKEN_ENV = "DOSIA_PROJECTS_USER_TOKEN";
/** 身份 token 的 JWT `aud`。facade 必须逐字比对，不接受其它 audience。 */
export const DOSIA_PROJECTS_JWT_AUDIENCE = "dosia-projects-mcp";
/** facade 唯一认的身份头（小写 —— Node 的 header 名恒为小写）。 */
export const DOSIA_PROJECTS_USER_TOKEN_HEADER = "x-dosia-projects-user-token";
//# sourceMappingURL=projects-mcp-contract.js.map